/**
 * Função para somar o valor total presente em uma propriedade de uma lista de objetos.
 * @template T
 * @param {T[]} dataList - Lista de objetos a ser iterada.
 * @param {string} columnName - Propriedade pela qual os objetos devem ser somados.
 * @returns {number} - Valor total da soma.
 */

export function sumColumnValueByListAndColumn(columnName, dataList) {
  if (/^\d{6}InvoiceData$/.test(columnName)) {
    const rawKey = columnName.replace('InvoiceData', ''); // ex.: "012025"
    return dataList.reduce((total, installation) => {
      const invoiceFound = installation.invoicesData.find(
        inv => inv.key === rawKey,
      );
      if (!invoiceFound) return total;
      return total + (invoiceFound.boletoVeins || 0);
    }, 0);
  }

  return dataList.reduce((total, payment) => total + payment[columnName], 0);
}
